import Vue from 'vue'
import { baseURL } from '../config'
import axios from 'axios'
import qs from 'qs'
// 更换头像
export const submitUpload = data => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=uploadAvatar&token=" + localStorage.getItem('token'), data)
// 余额
export const money = data => Vue.prototype.getAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=money&token=" + localStorage.getItem('token'), data)
// 充值
export const recharge = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 用户基础信息修改
export const updateUserInfo = (token, data) => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=updateUserInfo&token=" + token, data)
// 修改密码
export const getNewPwd = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 查询用户余额和待确认余额 
export const balanceTotal = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 个人中心首页各项统计
export const tabDataCount = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// Paypal
export const Paypal = data => axios({
    url: 'https://www.paypal.com/cgi-bin/webscr',
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})

// user列表数量
export const menuCount = data => Vue.prototype.getAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=menuCount&token=" + localStorage.getItem('token'), data)


//发送邮箱验证码
export const sendCodeToEmail = data => axios({
    url: 'https://www.rakumart-2c.com:8080/api/client/sendCodeToEmail',
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})

//保存扩展邮箱 
export const saveUserRelatedEmail = data => axios({
    url: 'https://www.rakumart-2c.com:8080/api/client/saveUserRelatedEmail',
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})

//提交客户链接 
export const submitLink = data => axios({
    url: 'https://www.rakumart-2c.com:8080/api/submitLink?token=' + localStorage.getItem('token'),
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})


